import { render } from "./RefundRequestDetailComponent.vue?vue&type=template&id=28bde1fc&scoped=true"
import script from "./RefundRequestDetailComponent.vue?vue&type=script&lang=js"
export * from "./RefundRequestDetailComponent.vue?vue&type=script&lang=js"

import "./RefundRequestDetailComponent.vue?vue&type=style&index=0&id=28bde1fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bde1fc"]])

export default __exports__